import { atom } from 'jotai';
import { atomWithReset } from 'jotai/utils';

import { SelectionState } from 'common/components/cookbook/DataTable/types';

export const selectedRecommendationsAtom = atomWithReset<SelectionState>({
  bulkSelect: false,
  selected: [],
  unselected: [],
});

selectedRecommendationsAtom.onMount = (set) => {
  return () => {
    set({
      bulkSelect: false,
      selected: [],
      unselected: [],
    });
  };
};

export const selectedProductFamilyIdsAtom = atom<string[]>([]);
